import { Component, Input, OnInit } from '@angular/core';
import { LevelMoveOrderReview } from 'store/level-move/models/order-review';
import { PlanSwitchOrderReview } from 'store/plan-eligibility/models/order-review';


@Component({
    selector: 'xm-estimated-next-bill',
    styleUrls: ['./estimated-next-bill.scss'],
    templateUrl: './estimated-next-bill.html',
    standalone: false
})
export class XmEstimatedNextBillComponent implements OnInit {
    @Input() public expandIconOptions: MediaImageOptions;
    @Input() public cmsData: PlanSwitchOrderReview | LevelMoveOrderReview;

    public btgExpandFlag: boolean = false;
    public tabletExpandFlag: boolean = false;
    public unlimitedExpandFlag: boolean = false;
    public nextBillExpandFlag: boolean = false;
    public planSwitchData: LevelMoveEstimatedNextBill;
    public unlimitedPlanGroup: LevelMoveDataPlanGroup;
    public byTheGigPlanGroup: LevelMoveDataPlanGroup;
    public tabletPlanGroup: LevelMoveDataPlanGroup;
    public serviceAndDevices: LevelMoveServicesAndDevices;
    public lineExpandFlags: boolean[];
    public smartWatchPlanGroup: LevelMoveDataPlanGroup;
    public smartWatchExpandFlag: boolean = false;

    public ngOnInit(): void {
        this.planSwitchData = this.cmsData.orderSummary.summaries.estimatedNextBill;
        this.unlimitedPlanGroup = this.cmsData.unlimitedPlanGroup;  
        this.byTheGigPlanGroup = this.cmsData.byTheGigPlanGroup;
        this.tabletPlanGroup = this.cmsData.tabletPlanGroup;
        this.smartWatchPlanGroup = this.cmsData.smartWatchPlanGroup;
        this.serviceAndDevices = this.planSwitchData.servicesAndDevices;
        this.buildProps();
    }

    public formatBodyContent(bodyContent?: string): string[] {
        return bodyContent ? bodyContent.split(/\\n|\r?\n/) : [];
    }

    private buildProps(): void {
        this.lineExpandFlags = this.serviceAndDevices.devices.map(() => false);
    }

}
